import FormEditor from '../../atoms/jsonFormEditor/FormEditor';
import { useState, useEffect } from 'react';
import { invokeGetService, handleSnackBar, invokeServerSentEventService, setDeployLoader, setBuildStatus } from '../../../store/global/actions';
import { useDispatch } from 'react-redux';
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress.js';
import { formatDateToYYYYMMDDHHMMSS } from '../../../utils/commonUtils';
import './style.css';

export default function RunSimulation({ onClose, setOpenSimulationLogs }) {
  const dispatch = useDispatch();
  const [isUpdating, setIsUpdating] = useState(false);
  const [loading, setLoading] = useState(false);
  const [schema, setSchema] = useState({});
  const [savedConfig, setSavedConfig] = useState(null)
  const [fetchedDeploys, setFetchedDeploys] = useState(null)
  const [initialDeployId, setInitialDeployId] = useState(null)
  const [schemaValues, setSchemaValues] = useState({});
  const [openAppView, setOpenAppView] = useState(false);
  const [viewToRedirect, setViewToRedirect] = useState(null);

  useEffect(() => {
    getDeploymentConfigurations();
    dispatch(invokeGetService('fetchViews', {}))
      .then((response) =>{
        const views = response.data;
        setViewToRedirect(views.find(view => view.default) || views.sort((a,b) => a.order - b.order)?.[0])
      }).catch(error => {
        console.log({error})
      })
  }, []);

  const getDeploymentConfigurations = async () => {
    setLoading(true);

    /**Get simulation configs */
    const promise_deploys = dispatch(invokeGetService('getDeploymentConfigurationList'));
    const promise_sims = dispatch(invokeGetService('getSimulationDeployConfig'));
    const promise_testsuites = dispatch(invokeGetService('listTestsuites', {}));
    const promise_testcases = dispatch(invokeGetService('listTestcases', {}));
    const promise_simulation_commands = dispatch(invokeGetService('getSimulationSavedCommands', {}));

    Promise.all([promise_sims, promise_deploys, promise_testsuites, promise_testcases, promise_simulation_commands]).then(([simulations, deploys, testsuites, testcases, savedCommands]) => {
      setFetchedDeploys(() => deploys.data)
      setupSchema(simulations.data, deploys.data, testsuites.data, testcases.data);
      setTimeout(() => {
        setLoading(false);
      }, 100);
      if (savedCommands != undefined && savedCommands.data != undefined && savedCommands.data != null) {
        setSavedConfig(() => savedCommands.data)
        dealSchemaData(savedCommands.data, deploys.data);
      }
    });
  };


  const dealSchemaData = (savedCommands, deploymentConfiguration) => {
    let schemData = {};

    if (savedCommands.simulationDeployment_id && savedCommands.simulationDeployment_id != '') schemData.simulationConfig = savedCommands.simulationDeployment_id;
    if (savedCommands.blueprintDeployment_id && savedCommands.blueprintDeployment_id != '') {
      schemData.deploymentConfig = savedCommands.blueprintDeployment_id;
      setInitialDeployId(savedCommands.blueprintDeployment_id)
    }

    const slices = setupSlices(savedCommands.blueprintDeployment_id, deploymentConfiguration, savedCommands)

    schemData = { ...schemData, ...slices }

    console.log({ slices, schemData, savedCommands });

    if (savedCommands.testsuite_id && savedCommands.testsuite_id != '') {
      schemData.simulation = {};
      schemData.simulation[savedCommands.testsuite_id] = savedCommands.testsuite_id;
      if (savedCommands.testcase_id && savedCommands.testcase_id != '') schemData.simulation.scenario = savedCommands.testcase_id;
      else schemData.simulation.scenario = 'select';
    }

    if (savedCommands.iterations != -1) schemData.iteration = savedCommands.iterations;
    if (savedCommands.parallel != -1) schemData.parallel = savedCommands.parallel;
    if (savedCommands.logLevel && savedCommands.logLevel != '') schemData.loglevel = savedCommands.logLevel;
    if (savedCommands.appArguments && savedCommands.appArguments != '') schemData.customArguments = savedCommands.appArguments;

    setSchemaValues(schemData);
  };

  const  sortElements = (dropDownOptions, itemsWithOrder) =>  {

    const orderMap = new Map(
      itemsWithOrder.map((item) => [item._id, item.order])
    );

    return dropDownOptions.sort((a, b) => {
        if (a.value === "select") return -1;
        if (b.value === "select") return 1;

        const orderA = orderMap.get(a.value) ?? Infinity;
        const orderB = orderMap.get(b.value) ?? Infinity;

        return orderA - orderB;
    });
}
  
  const setupSchema = (simulationData, deployData, allTestsuites, allTestcases) => {
    /** Fill simulation configurations */
    let simulationConfigs = [{ title: 'Select', value: 'select' }];
    simulationData.forEach((simulate) => {
      simulationConfigs.push({ title: simulate.name, value: simulate._id });
    });

    /** Fill deployment configurations */
    let deploymentConfigs = [{ title: 'Select', value: 'select' }];
    deployData.forEach((deploy) => {
      console.log({ deploy });
      deploymentConfigs.push({ title: deploy.configuration_name, value: deploy._id });
    });

    /** Fill testcases */
    /** There can be multiple test cases with same name, but scenario will be different */

    let testsuites = [{ title: 'Select', value: 'select' }];
    let testcases = [{ title: 'Select', value: 'select' }];

    allTestsuites.forEach((testsuite) => {
      let existingTestsuite = testsuites.find((s) => s.title == testsuite.name);
      if (!existingTestsuite) {
        testsuites.push({ title: testsuite.name, value: testsuite._id });
      }
    });

    allTestcases.forEach((testcase) => {
      let existingTestcase = testcases.find((s) => s.title == testcase.name);
      if (!existingTestcase) {
        testcases.push({ title: testcase.name, value: testcase._id });
        // setScenarioList([...scenarioList, { title: scenario.scenario, value: scenario._id }])
      }
    });

    const loglevels = [
      { value: 1, title: 'High' },
      { value: 2, title: 'Medium' },
      { value: 3, title: 'Low' },
    ];

    testsuites = sortElements(testsuites, allTestsuites);

    const testCaseSchema = [...testsuites].map((item) => {
      let singleSchema = {
        title: item.title,
        type: 'object',
        default: item.value,
        properties: {
          [item.value]: { default: item.value, type: 'string', options: { hidden: true } },
        },
        additionalProperties: false,
        options: {
          // disable_properties: false,
          layout: 'grid',
          grid_columns: 12,
        },
      };

      let testsuiteTestcases = allTestcases
        .filter((testcase) => testcase?.testsuite_id == item.value)
        .map((ele) => {
          return { title: ele.name, value: ele._id };
        });

      testsuiteTestcases = sortElements(testsuiteTestcases, allTestcases);

      const scenarioSchema = {
        scenario: {
          type: 'string',
          title: 'Testcase',
          enumSource: [
            {
              source: [{ title: 'Select', value: 'select' }, ...testsuiteTestcases],
              title: '{{item.title}}',
              value: '{{item.value}}',
            },
          ],
          //oneOf: [...mappingEventSchema],
          options: {
            disable_properties: false,
            layout: 'grid',
            grid_columns: 12,
          },
        },
      };

      singleSchema = { ...singleSchema, properties: { ...singleSchema.properties, ...scenarioSchema } };

      return singleSchema;
    });

    let schemaCandidate = {
      type: 'object',
      required: ['simulationConfig', 'deploymentConfig', 'sslice', 'rslice', 'simulation'],
      options: {
        layout: 'grid',
        disable_properties: false,
        grid_columns: 12,
      },
      properties: {
        simulationConfig: {
          type: 'string',
          title: 'Simulation Environment',
          enumSource: [
            {
              source: simulationConfigs,
              title: '{{item.title}}',
              value: '{{item.value}}',
            },
          ],
          options: {
            // input_width: '200px',
            disable_properties: false,
            layout: 'grid',
            grid_columns: 6,
          },
        },

        deploymentConfig: {
          type: 'string',
          title: 'Deployment Environment',
          enumSource: [
            {
              source: deploymentConfigs,
              title: '{{item.title}}',
              value: '{{item.value}}',
            },
          ],
          options: {
            // input_width: '200px',
            disable_properties: false,
            layout: 'grid',
            grid_columns: 6,
          },
        },

        rslice: {
          type: 'string',
          title: 'Resource Slice',
          options: {
            disable_properties: false,
            layout: 'grid',
            grid_columns: 6
          }
        },
        sslice: {
          type: 'string',
          title: 'Service Slice',
          options: {
            disable_properties: false,
            layout: 'grid',
            grid_columns: 6
          }
        },

        // simulation: {
        //     type: 'string',
        //     title: 'Testcase',
        //     enumSource: [{
        //         source: simulations,
        //         title: '{{item.title}}',
        //         value: '{{item.value}}'
        //     }],
        //     //oneOf: [...mappingEventSchema],
        //     options: {
        //         disable_properties: false,
        //         layout: 'grid',
        //         grid_columns: 2
        //     }
        // },

        simulation: {
          title: 'Testsuite',
          oneOf: [...testCaseSchema],
          options: {
            disable_properties: true,
            layout: 'grid',
            grid_columns: 12,
          },
        },

        // scenario: {
        //     type: 'string',
        //     title: 'Scenario',
        //     enumSource: [{
        //         source: scenarios,
        //         title: '{{item.title}}',
        //         value: '{{item.value}}'
        //     }],
        //     //oneOf: [...mappingEventSchema],
        //     options: {
        //         disable_properties: false,
        //         layout: 'grid',
        //         grid_columns: 2
        //     }
        // },

        iteration: {
          type: 'integer',
          title: 'Iterations',
          options: {
            disable_properties: false,
            layout: 'grid',
            grid_columns: 6,
          },
          default: 1
        },

        parallel: {
          type: 'integer',
          title: 'Parallel',
          options: {
            disable_properties: false,
            layout: 'grid',
            grid_columns: 6,
          },
          default: 1
        },

        // loglevel: {
        //   type: 'string',
        //   title: 'Log level',
        //   // enumSource: [
        //   //   {
        //   //     source: loglevels,
        //   //     title: '{{item.title}}',
        //   //     value: '{{item.value}}',
        //   //   },
        //   // ],
        //   //oneOf: [...mappingEventSchema],
        //   options: {
        //     disable_properties: false,
        //     layout: 'grid',
        //     grid_columns: 6,
        //     // input_width: '100%',
        //   },
        // },

        customArguments: {
          type: 'string',
          title: 'Application specific arguments ( as in command )',
          options: {
            disable_properties: false,
            layout: 'grid',
            grid_columns: 12,
          },
        },

        strictCheck: {
          type: 'boolean',
          default: true,
          title: 'Validate incoming message',
          options: {
            // disable_properties: false,
            // layout: 'grid',
            // grid_columns: 12,
            hidden: true
          },
        },
      },
    };
    console.log("schemaCandidate--------->", schemaCandidate)

    setSchema(schemaCandidate);
  };


  const options = {
    form_name_root: 'run_simulation',
    show_errors: 'never',
  };

  // let schemaValues = {}
  let id = 123;
  let parentID = 123;
  let rootId = 123;
  let randomNumber = 123;

  const customizeRunSimulationEditor = () => {
    const run_simulationDiv = document.querySelector(`[data-schemapath="run_simulation"]`);
    if (run_simulationDiv) {
      // For customising properties button
      const propertiesBtn = document.querySelectorAll('.json-editor-btn-edit_properties.json-editor-btntype-properties');
      if (propertiesBtn?.length > 0) {
        propertiesBtn.forEach((btn) => {
          btn.textContent = 'Choose Arguments';
          btn.title = 'Choose Arguments';
        });
      }

      // For customizing with of each fields
      const simulationConfigDiv = run_simulationDiv.querySelector(`[data-schemapath="run_simulation.simulationConfig"]`);
      if (simulationConfigDiv) {
        simulationConfigDiv.classList = [];
        simulationConfigDiv.classList.add('col-md-6');
      }

      const deploymentConfigDiv = run_simulationDiv.querySelector(`[data-schemapath="run_simulation.deploymentConfig"]`);
      if (deploymentConfigDiv) {
        deploymentConfigDiv.classList = [];
        deploymentConfigDiv.classList.add('col-md-6');
      }

      const simulationFieldDiv = run_simulationDiv.querySelector(`[data-schemapath="run_simulation.simulation"]`);
      if (simulationFieldDiv) {
        simulationFieldDiv.classList = [];
        simulationFieldDiv.classList.add('col-md-12');
      }

      const simulationScenarioDiv = run_simulationDiv.querySelector(`[data-schemapath="run_simulation.simulation.scenario"]`);
      if (simulationScenarioDiv) {
        // console.log('true------------------')
        simulationScenarioDiv.classList = [];
        simulationScenarioDiv.classList.add('col-md-12');
      }

      const iterationFieldDiv = run_simulationDiv.querySelector(`[data-schemapath="run_simulation.iteration"]`);
      if (iterationFieldDiv) {
        iterationFieldDiv.classList = [];
        iterationFieldDiv.classList.add('col-md-6');
      }

      const parallelFieldDiv = run_simulationDiv.querySelector(`[data-schemapath="run_simulation.parallel"]`);
      if (parallelFieldDiv) {
        parallelFieldDiv.classList = [];
        parallelFieldDiv.classList.add('col-md-6');
      }

      const logLevelDiv = run_simulationDiv.querySelector(`[data-schemapath="run_simulation.loglevel"]`);
      if (logLevelDiv) {
        logLevelDiv.classList = [];
        logLevelDiv.classList.add('col-md-6');
      }

      const customArgumentsFieldDiv = run_simulationDiv.querySelector(`[data-schemapath="run_simulation.customArguments"]`);
      if (customArgumentsFieldDiv) {
        customArgumentsFieldDiv.classList = [];
        customArgumentsFieldDiv.classList.add('col-md-12');
      }
    }
  };

  const setupSlices = (deploymentConfigId, fetchedDeploymentConfig, savedCommands, log) => {
    console.log(log)
    let schemaData = {
      ...schemaValues
    }

    const selectedDeployment = deploymentConfigId ? fetchedDeploymentConfig?.find((item) => item?._id === deploymentConfigId) : null

    let sslice = ''
    let rslice = ''

    console.log({ initialDeployId, deploymentConfigId, savedConfig }, 'this is initial deployment ID');

    if ((initialDeployId !== deploymentConfigId || (!savedConfig.rslice && savedCommands?.rslice))) {
      if (!initialDeployId && (savedConfig || savedCommands)) {
        rslice = (savedConfig || savedCommands)?.rslice
      } else {
        rslice = selectedDeployment?.rslice
      }

    } else {
      rslice = (savedConfig || savedCommands)?.rslice
    }

    if ((initialDeployId !== deploymentConfigId || (!savedConfig.sslice && savedCommands?.sslice))) {
      if (!initialDeployId && (savedConfig || savedCommands)) {
        sslice = (savedConfig || savedCommands)?.sslice
      } else {
        sslice = selectedDeployment?.sslice
      }
    } else {
      sslice = (savedConfig || savedCommands)?.sslice
    }

    console.log({ rslice, sslice, selectedDeployment, deploymentConfigId, fetchedDeploymentConfig });

    schemaData.sslice = sslice;
    schemaData.rslice = rslice;

    return {
      sslice, rslice
    }
  }

  const onChangeJsonEditor = function (data) {
    console.log('dataa----json---->', data);

    if (fetchedDeploys) {
      const slices = setupSlices(data?.deploymentConfig, fetchedDeploys)
      let schemaData = { ...schemaValues, ...data, ...slices }
      if (data?.deploymentConfig !== schemaValues?.deploymentConfig) {
        setSchemaValues(schemaData)
      }
    }

    customizeRunSimulationEditor();
  };

  console.log({ schemaValues });

  const extractBlueprintId = (string) => {

    var regex = /<bpid>(.*?)<\/bpid>/;
    var match = string.match(regex);

    var bpidValue = match ? match[1] : null;
    var actualMsg = string.replace(regex, '').trim();

    return { bpidValue, actualMsg }

  }

  const onMessageCallback = (data) => {

    console.log('data-------response', data)
  };

  const onErrorCallback = (error) => {
    console.log('data in----------', error, typeof error)
    const formattedDate = formatDateToYYYYMMDDHHMMSS(new Date());
    // dispatch(handleLogs(`${formattedDate} : [error]${error}[/error]`));
    if (error.trim() == 'Blueprint is not built/deployed') {
      dispatch(setBuildStatus(false))
    }
  };

  const onCloseCallback = (event) => {
    dispatch(setDeployLoader({ status: false }));
  };

  const formatFormData = (formdata) => {
    let finalFormData = {};

    if (formdata.simulationConfig) finalFormData.simulationConfig = formdata.simulationConfig;
    if (formdata.deploymentConfig) finalFormData.deploymentConfig = formdata.deploymentConfig;
    if (formdata.sslice) finalFormData.sslice = formdata.sslice?.trim();
    if (formdata.rslice) finalFormData.rslice = formdata.rslice?.trim();
    
    if (formdata.simulation && formdata.simulation != 'select') {
      if (Object.keys(formdata.simulation)[0] != 'select') {
        finalFormData.testsuite = Object.keys(formdata.simulation).find(key => key === formdata.simulation[key]);
        
      }
      if (formdata.simulation.scenario != 'select') {
        finalFormData.testcase = formdata.simulation.scenario;
      }
    }
    if (formdata.iteration != undefined) finalFormData.iteration = formdata.iteration;
    if (formdata.parallel != undefined) finalFormData.parallel = formdata.parallel;
    if (formdata.loglevel) finalFormData.loglevel = formdata.loglevel;
    if (formdata.customArguments) finalFormData.customArguments = formdata.customArguments;
    if (formdata.strictCheck) finalFormData.strictCheck = formdata.strictCheck;


    console.log({finalFormData})
    return finalFormData;
  };

  const onRunSimulation = async function (formData) {
    dispatch(setBuildStatus(true))
    let formattedFormdata = formatFormData(formData);
    setTimeout(() => {

    },[])
    setIsUpdating(true);
    // dispatch(handleSnackBar({ open: true, message: 'Triggering simulation...', severity: 'info' }));
    dispatch(invokeServerSentEventService('runSimulation', { ...formattedFormdata }, onMessageCallback, onErrorCallback, onCloseCallback, true));
    if(openAppView){
      setTimeout(async () => {
        const redirectionDetails = await dispatch(invokeGetService('redirectLink', {
          deploymentId: formattedFormdata?.deploymentConfig,
          sslice: formattedFormdata.sslice,
          rslice: formattedFormdata.rslice
        }, true))
        if(redirectionDetails.status){
          let link;
          if(redirectionDetails.status){
            link = redirectionDetails.url;
            link += `/view_${viewToRedirect?.name}`
          }
      
          if(link){
            window.open(link)
          }else{
            dispatch(handleSnackBar({open: true, severity: "error", message: redirectionDetails?.message || "Something went wrong"}))
          }
        }
      }, 3000)
    }
    setTimeout(() => {
      setOpenSimulationLogs(true)
      onClose();
      setIsUpdating(false);
    }, 50)
    // dispatch(closeBottomTerminal(false))
    // dispatch(handleBottomTerminal(true, 'Run Simulation'));
    // dispatch(setDeployLoader({ status: true }));

  };

  const validation = function (schema, value, path) {
    return [];
  };

  const customValidation = function (data) {
    let errors = [];
    if (data?.simulationConfig == 'select') {
      errors.push({
        path: 'run_simulation.simulationConfig',
        property: 'format',
        message: 'Simulation environment is required',
      });
    }

    if (data?.deploymentConfig == 'select') {
      errors.push({
        path: 'run_simulation.deploymentConfig',
        property: 'format',
        message: 'Deployment environment is required',
      });
    }

    if (data?.simulation?.hasOwnProperty('select')) {
      errors.push({
        path: 'run_simulation.simulation',
        property: 'format',
        message: 'Testsuite is required',
      });
      dispatch(handleSnackBar({ open: true, message: 'Choose any testsuite', severity: 'error' }))
    }

    if (data.simulation && data.simulation == 'select') {
      errors.push({
        path: 'run_simulation.simulation',
        property: 'format',
        message: 'Testcase is required',
      });
    }

    if (data.scenario && data.scenario == 'select') {
      errors.push({
        path: 'run_simulation.scenario',
        property: 'format',
        message: 'Scenario is required',
      });
    }

    return errors;
  };

  return (
    <>
      {loading && <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '18vh', marginBottom: '18vh' }} />}

      {!loading && (
        <FormEditor
          onChangeJsonEditor={onChangeJsonEditor}
          options={options}
          schema={schema}
          onSave={onRunSimulation}
          onClose={onClose}
          schemaValues={schemaValues}
          validation={validation}
          key={JSON.stringify(schema)}
          keySchema={JSON.stringify(schemaValues)}
          parentID={parentID}
          action={'run'}
          customValidation={customValidation}
          isUpdating={isUpdating}
          randomNumber={randomNumber}
          openAppView={openAppView}
          setOpenAppView={setOpenAppView}
          showAppViewOption
        />
      )}
    </>
  );
}
